import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pds-sprite-icons',
  templateUrl: './sprite-icons.component.html',
  styleUrls: ['./sprite-icons.component.scss']
})
export class SpriteIconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
